import { datadogRum } from '@datadog/browser-rum';
import { Suspense } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router';

import CookieCutter from '../components/cookies/cookieCutter';
import PageSpinner from '../components/molecules/pageSpinner';
import ErrorPage from '../components/pages/errorPage';
import LandingPage from '../components/pages/landingPage';
import LoginForm from '../components/pages/userAccount/loginform';

import ReactRouterErrorBoundary from './reactErrorBoundary';
import Root from './Root';
import { activityRoutes } from './routes/activity';
import { approvalRoutes } from './routes/approvals';
import { cardUserRoutes } from './routes/cardUsers';
import { cookieRoutes } from './routes/cookie';
import { dashboardRoutes } from './routes/dashboard';
import { demoRoutes } from './routes/demo';
import { errorRoutes } from './routes/error';
import { settlementRoutes } from './routes/manageSettlements';
import { requestRoutes } from './routes/request';
import { settingsRoutes } from './routes/settings';
import { signinRoutes } from './routes/signin';
import { supportRoutes } from './routes/support';
import { supportAdminSettingsRoutes } from './routes/supportSettings';
import { teamRoutes } from './routes/team';
import { teamsManageSettlements } from './routes/teamsManageSettlements';
import { tosRoutes } from './routes/tos';
import { walletRoutes } from './routes/wallet';
import './GoAppStyle.less';

export const excludedPaths = ['signin', 'tos', 'request-demo', 'cookie-notice']; // on these routes we do not want to show the main sidemenu

globalThis.DD_RUM = datadogRum;

const router = createBrowserRouter(
	[
		{
			path: '/',
			element: (
				<Root>
					<div className="content-right">
						<Outlet />
						<Suspense fallback={<div />}>
							{globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? <CookieCutter /> : null}
						</Suspense>
					</div>
				</Root>
			),
			errorElement: (
				<Root>
					<ReactRouterErrorBoundary />
				</Root>
			),
			hydrateFallbackElement: <PageSpinner />,
			children: [
				{ path: '/', element: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? <LoginForm /> : <LandingPage /> },
				walletRoutes,
				dashboardRoutes,
				errorRoutes,
				activityRoutes,
				approvalRoutes,
				settlementRoutes,
				teamsManageSettlements,
				cardUserRoutes,
				requestRoutes,
				settingsRoutes,
				teamRoutes,
				signinRoutes,
				demoRoutes,
				supportRoutes,
				supportAdminSettingsRoutes,
				tosRoutes,
				cookieRoutes,
			],
		},

		{
			path: '*',
			element: (
				<Root>
					<ErrorPage />
				</Root>
			),
		},
	],
	{
		future: {
			//There are no current future flags in React Router v7
		},
	},
);

const GoApp = () => {
	return (
		<Suspense fallback={<PageSpinner isLoading={true} />}>
			<RouterProvider router={router} />
		</Suspense>
	);
};

export default GoApp;
